import { render, staticRenderFns } from "./peosonalDetail.vue?vue&type=template&id=7b861e9e&scoped=true"
import script from "./peosonalDetail.vue?vue&type=script&lang=js"
export * from "./peosonalDetail.vue?vue&type=script&lang=js"
import style0 from "./peosonalDetail.vue?vue&type=style&index=0&id=7b861e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b861e9e",
  null
  
)

export default component.exports